import { render } from "./DonorClinicalSectionEMROATS.vue?vue&type=template&id=d6075922&scoped=true"
import script from "./DonorClinicalSectionEMROATS.vue?vue&type=script&lang=js"
export * from "./DonorClinicalSectionEMROATS.vue?vue&type=script&lang=js"

import "./DonorClinicalSectionEMROATS.vue?vue&type=style&index=0&id=d6075922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6075922"],['__file',"src/components/DonorClinicalSectionEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6075922"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6075922', __exports__)) {
    api.reload('d6075922', __exports__)
  }
  
  module.hot.accept("./DonorClinicalSectionEMROATS.vue?vue&type=template&id=d6075922&scoped=true", () => {
    api.rerender('d6075922', render)
  })

}


export default __exports__